import { useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import styles from "./HomeShowcaseSection.module.css";

gsap.registerPlugin(ScrollTrigger);

const HomeShowcaseSection = () => {
  const sectionRef = useRef(null);
  const aboutRef = useRef(null);
  const appointmentRef = useRef(null);
  const instagramRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      /*
       * ABOUT
       * Soft vertical entrance.
       */
      gsap.fromTo(
        aboutRef.current,
        {
          opacity: 0,
          y: 90,
        },
        {
          opacity: 1,
          y: 0,
          duration: 1.25,
          ease: "power4.out",
          scrollTrigger: {
            trigger: aboutRef.current,
            start: "top 82%",
            once: true,
          },
        },
      );

      /*
       * APPOINTMENT
       * Horizontal editorial slide.
       */
      gsap.fromTo(
        appointmentRef.current,
        {
          opacity: 0,
          x: -110,
        },
        {
          opacity: 1,
          x: 0,
          duration: 1.4,
          ease: "expo.out",
          scrollTrigger: {
            trigger: appointmentRef.current,
            start: "top 82%",
            once: true,
          },
        },
      );

      /*
       * INSTAGRAM
       * Gentle scale + fade.
       */
      gsap.fromTo(
        instagramRef.current,
        {
          opacity: 0,
          scale: 0.88,
        },
        {
          opacity: 1,
          scale: 1,
          duration: 1.5,
          ease: "power3.out",
          scrollTrigger: {
            trigger: instagramRef.current,
            start: "top 82%",
            once: true,
          },
        },
      );
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section ref={sectionRef} className={styles.showcase}>
      <article className={`${styles.showcaseItem} ${styles.aboutItem}`}>
        <div ref={aboutRef} className={styles.content}>
          <NavLink to="/about" className={styles.titleLink}>
            About
            <span>Marléna</span>
          </NavLink>
        </div>
      </article>

      <article
        className={`${styles.showcaseItem} ${styles.appointmentsItem}`}
      >
        <div ref={appointmentRef} className={styles.content}>
          <NavLink to="/inquiry" className={styles.titleLink}>
            Book an
            <span>Appointment</span>
          </NavLink>
        </div>
      </article>

      <article className={`${styles.showcaseItem} ${styles.instagramItem}`}>
        <div ref={instagramRef} className={styles.content}>
          <a
            href="https://www.instagram.com/marlenatattoo/"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.titleLink}
          >
            Instagram
          </a>
        </div>
      </article>
    </section>
  );
};

export default HomeShowcaseSection;